<template >
  <div class="row">
    <div
        :class="'col col-12 col-md-4' + (inputModel.is_inverted? ' order-2': '')"
    >
      <image-component
          v-model="inputModel.image"
          :type-id="inputObj.params.image_type_id"
          :type-id-old="config.image.image_type_id"
          :is_browser="true"
          :is_upload="true"
          :is_input_title="true"
          :is_input_copyright="true"
          :is_delete="false"
          :is_preview_only="false"
          :thumb_type_id="60"
          :is_image_props="true"
          thumb_class="segment img-thumbnail img-fluid"
      />
      <!--
            <display-debug>
              <template #debugView>
                inputObj: {{inputObj.params.image_type_id}}
              </template>         </display-debug>



            <display-debug>
              <template #debugView>
                config: {{config}}
              </template>
            </display-debug>
      -->
    </div>
    <div
        :class="'col col-12 col-md-8' + (inputModel.is_inverted? ' order-1': '')"
    >
      <ul class="nav nav-tabs mb-2">
        <li
            v-for="(langItem, langIndex)  in lang"
            class="nav-item"
        >
          <a
              :class="'nav-link' + ((activeTab == langIndex)? ' active':'')"
              @click.prevent="changeTab(langIndex)"
              href="#"
          >
            <country-flag
                :country='langItem.flag'
                size="small"
            />
            {{langItem.title}}

          </a>
        </li>
      </ul>
      <template
               v-for="(langItem, langIndex)  in lang"
      >

             <div
                 v-show="activeTab == langIndex"
             >
               <html-editor2
                   v-if="inputObj.params && inputObj.params.is_wysiwig"
                   v-model="inputModel.text[langIndex]"
                   editor-type="segment_odstavec"
               />
               <textarea
                   v-else
                   v-model="inputModel.text[langIndex]"
                   :id="inputObj.name + '_lang_' + langIndex"
                   type="text"
                   class="form-control"
               >
             </textarea>

             </div>

           </template>
    </div>

    <div class="col col-12 col-md-12  order-3">
      <div class="form-check form-switch mt-2 mb-2">
        <input

            v-model="inputModel.is_inverted"
            class="form-check-input"
            type="checkbox"
            role="switch"
            :id="'is_inverted'"
        >
        <label
            class="form-check-label"
            :for="'is_inverted'"
        >
          je prohozene
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import ImageComponent from "@/components/general/Image";
import htmlEditor2 from "@/components/content/htmlEditor_v2.vue";
import CountryFlag from "vue-country-flag-next"

export default {
  name: "HeroSegment",
  components: {
    CountryFlag,
    htmlEditor2,
    //ImagePreview,
    ImageComponent,
  },
  props: {
    "segmentsObj": [Object, Array],
    "inputObj": Object,
    "formObj": Object,
    "modelValue": [Number,String, Object],
    "lang": {
      type: [Object],
      required: false,
    },
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
    "config": {
      type: [Object],
      required: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      inputModel: {
        image:null,
        text: null,
        is_inverted: false,
      },
      activeTab: null,
    }
  },
  created() {
    if(this.lang) {
      //this.inputModel = {}
      this.inputModel.text = {};
      for (const i in this.lang){
        if(this.activeTab === null) {
          this.activeTab = i;
        }

        this.inputModel.text[i] = null;
      }

      if(this.inputObj.obsah) {
        this.createInputModelValues(this.inputObj.obsah)
      }
    }
  },
  mounted() {

/*
    if(this.inputObj.obsah) {
      console.log("dev hero mounted", this.inputObj.obsah)
      this.createInputModelValues(this.inputObj.obsah)
      //this.inputModel = this.inputObj.obsah;
    }
  */
  },
  methods: {
    changeTab(index) {
      this.activeTab = index;
    },
    createInputModelValues(data) {

      for(const i in this.inputModel) {
        if(typeof data[i] !== "undefined") {
          if(i == "text") {
            for(const j in this.inputModel[i]) {
              this.inputModel[i][j] = data[i][j];
            }
          }else{
            this.inputModel[i] = data[i];
          }
        }
      }
    }
  },
  watch: {
    inputObj: {
      handler(newVal, oldVal) {
        if(newVal.obsah) {
          this.createInputModelValues(newVal.obsah)
        }
      },
      deep: true,
      immediate: true
    },
    inputModel: {
      handler(newVal, oldVal) {
        if(typeof oldVal != "undefined") {
          this.$emit('update:modelValue', newVal )
        }
      },
      deep: true,
      immediate: true
    },

  },
};
</script>